import Vue from 'vue'
import App from './App.vue'
import VueResource from 'vue-resource';
import 'jquery/dist/jquery.js'
import './assets/js/fontawesome';

Vue.use(VueResource);

new Vue({
  el: '#SBY-holder',
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js